// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1417n","infoBtn":"quickbooks_infoBtn__gCb8T","formBox":"quickbooks_formBox__3WteK","formFooter":"quickbooks_formFooter__1UQ_c"};